export function useBase64() {
    const decode = (base64String: string): string => {
        const binString = atob(base64String);
        const bytes = Uint8Array.from(binString, (char) => char.charCodeAt(0));
        return new TextDecoder().decode(bytes);
    };

    return {
        decode
    };
}